module.exports = __webpack_public_path__ + "img/btn_collect.4240a18c.png";